import React from "react";
import { CellProps } from "react-table";
import AgTable from "../../../components/AgTable";
import { TblInboxMessageDashboardStaff } from "../../../models";
import { DEFAULT_VALUE, OFFERING_TYPE } from "../../../utils/constant";
import { convertOfferingToName } from "../../../utils/convertHelper";
import { formatDateTimeNoSecond, formatDateTimeToLocalTime } from "../../../utils/helper";
import { IMessageSentTabProps } from "./messageSentTab.props";

const MessageSentTab: React.FC<IMessageSentTabProps> = (
    {
        data,
        maxLength,
        entriesPerPage = DEFAULT_VALUE.ENTRIES_PER_PAGE,
        onHandleNextPage,
        page = 1,
        pageCount,
        isLoading,
        offeringType,
        ...props
    }: IMessageSentTabProps
) => {
    const columns = React.useMemo(
        () => [
            {
                Header: "Sender name",
                width: "14%",
                Cell: ({ cell, row }: CellProps<TblInboxMessageDashboardStaff, any>) => {
                    const rowData = row.original

                    return <div className="flex flex-col items-start">
                        <p className="text-[14px] text-[#58585B] font-medium m-0 p-0">{`${rowData.fkFromIndividual?.firstName} ${rowData.fkFromIndividual?.lastName}`}</p>
                        {/* <p className="text-[14px] text-[#637381] font-normal m-0 p-0">{rowData.fkFromIndividual?.individualEmailAddr}</p> */}
                    </div>
                }
            },
            {
                Header: "Sender organization",
                width: "14%",
                Cell: ({ cell, row }: CellProps<TblInboxMessageDashboardStaff, any>) => {
                    const rowData = row.original

                    return <p className="">{rowData.firmOfFrom?.orgName}</p>
                }
            },
            {
                Header: " Action ",
                width: "10%",
                Cell: ({ cell, row }: CellProps<TblInboxMessageDashboardStaff, any>) => {
                    const rowData = row.original

                    return <p className="">{rowData.action}</p>
                }
            },
            {
                Header: "Receiver",
                width: "14%",
                Cell: ({ cell, row }: CellProps<TblInboxMessageDashboardStaff, any>) => {
                    const rowData = row.original

                    return <p className="">{rowData.inboxRecipientsMappingsDashboards?.map(e => `${e.toIndividual?.firstName} ${e.toIndividual?.lastName}`).join("; ")}</p>
                }
            },
            {
                Header: "Receiver organization",
                width: "14%",
                Cell: ({ cell, row }: CellProps<TblInboxMessageDashboardStaff, any>) => {
                    const rowData = row.original

                    return <p className="">{rowData.fkOrgId && rowData.fkOrg ? rowData.fkOrg.orgName :
                        rowData.firmOfTo?.orgName}</p>
                }
            },
            ...(offeringType !== OFFERING_TYPE.ORGANIZATION ? [{
                Header: convertOfferingToName(offeringType ?? OFFERING_TYPE.SERVICE),
                width: "14%",
                Cell: ({ cell, row }: CellProps<TblInboxMessageDashboardStaff, any>) => {
                    const rowData = row.original

                    return <p className="">{ rowData.mainServiceOfSubService && rowData.mainServiceOfSubService.length ? rowData.mainServiceOfSubService.map(e => e.mainServiceName).join("; ") : rowData.other ? "Other" : ""}</p>
                }
            }] : []),
            {
                Header: "Time stamp",
                width: "13%",
                Cell: ({ cell, row }: CellProps<TblInboxMessageDashboardStaff, any>) => {
                    const rowData = row.original

                    return <p className="">{formatDateTimeNoSecond(formatDateTimeToLocalTime(rowData.createdLogTime))}</p>
                }
            },
        ],
        [offeringType]
    );

    return <AgTable
        columns={columns}
        data={data}
        maxLength={maxLength}
        entriesPerPage={entriesPerPage}
        onHandleNextPage={onHandleNextPage}
        page={page}
        pageCount={pageCount}
        isLoading={isLoading}
    />
}

export default React.memo(MessageSentTab)